import React, { useState } from "react";
import "./Category.scss";
import { FiChevronLeft, FiPlay } from "react-icons/fi";
import { Link } from "react-router-dom";

const Category = (props) => {
  const cards = [
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
    { img: "/images/bg/1.webp" },
    { img: "/images/bg/2.jpg" },
    { img: "/images/bg/3.jfif" },
    { img: "/images/bg/4.jfif" },
    { img: "/images/bg/5.png" },
  ];

  return (
    <div className="Category-inner">
      {/*  */}
      <div className="middle container ">
        <div className="d-flex justify-content-start my-3 border-bottom pb-3">
          <button
            className=" btn btn-link mr-3 d-flex align-items-center"
            onClick={() => {
              props.history.goBack();
            }}
          >
            <FiChevronLeft /> Back
          </button>
          <h1 className="h1 font-weight-bold text-black-50 ">
            Popular Courses
          </h1>
        </div>
        <div className="bg-white wrapper">
          <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
            {cards.map((item, i) => (
              <div className="col my-3" key={i}>
                <div className="card h-100 shadow-sm ">
                  <img src={`${item.img}`} className="card-img-top" alt="..." />
                  <div className="card-body">
                    <Link to="/course-detail/name" className="play">
                      <FiPlay />
                    </Link>
                    <h5 className="card-title h2 font-weight-bold ">
                      Piano For Beginners
                    </h5>
                    <div className="h3 font-weight-bold text-success mt-2 mb-3">
                      $ 500
                    </div>
                    <p className="card-text text-muted font-weight-light h5 ">
                      This is a wider card with supporting text below as a
                      natural lead-in to additional content. This content is a
                      little bit longer.
                    </p>
                  </div>
                  <div className="card-footer bg-white ">
                    <div className="h5 font-weight-light footer-text">
                      {" "}
                      4 Lectures | 40 hr | John Doe{" "}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="bg-light rounded-lg p-3 h4 text-muted text-center d-flex justify-content-center align-items-center">
          <div className="spinner-border mr-3" role="status">
            <span className="visually-hidden"></span>
          </div>{" "}
          Loading... Please wait
        </div>
      </div>
      {/*  */}
    </div>
  );
};

export default Category;
